/** Rounds half-up to two decimals (e.g. 0.145 → 0.15) — `toPrecision` first strips binary float noise. */
export function roundTo2(value: number): number {
  return Math.round(Number((value * 100).toPrecision(12))) / 100;
}
